<template>
  <div v-if="exhibit === ''" class="opacity-0 absolute pointer-events-none">
    <img src="/uploads/exhibit_1.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits')" />
    <img src="/uploads/exhibit_2.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits')" />
    <img src="/uploads/exhibit_3.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits')" />
    <img src="/uploads/cable_monkey.png" alt="" @load="$store.commit('loader/setLoaded', 'monkey')" />
    <img src="/uploads/power_outlet.png" alt="" @load="$store.commit('loader/setLoaded', 'outlet')" />
    <img src="/uploads/concrete_structure.png" alt="" @load="$store.commit('loader/setLoaded', 'concrete')" />
    <img
      :src="`/uploads/keyvisual_logo_type_landscape_${$t('langShort')}.png`"
      @load="$store.commit('loader/setLoaded', 'logo')"
    />
  </div>
  <div v-else-if="exhibit === 'exhibit_a'" class="opacity-0 absolute pointer-events-none">
    <img src="/uploads/exhibit_1.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits1')" />
    <img src="/uploads/exhibit_2.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits2')" />
    <img src="/uploads/exhibit_3.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits3')" />
    <img src="/uploads/cable_monkey.png" alt="" @load="$store.commit('loader/setLoaded', 'monkey')" />
    <img src="/uploads/power_outlet.png" alt="" @load="$store.commit('loader/setLoaded', 'outlet')" />
    <img src="/uploads/concrete_structure.png" alt="" @load="$store.commit('loader/setLoaded', 'concrete')" />
    <img src="/uploads/ape_cable.png" alt="" @load="$store.commit('loader/setLoaded', 'ape')" />
    <img src="/uploads/exhibit_image_a.png" alt="" @load="$store.commit('loader/setLoaded', 'middle')" />
    <img
      src="/uploads/exhibit_background_a.jpg"
      alt=""
      @load="$store.commit('loader/setLoaded', 'background')"
    />
    <img src="/uploads/foreground_tree.png" alt="" @load="$store.commit('loader/setLoaded', 'foreground')" />
  </div>

  <div v-else-if="exhibit === 'exhibit_b'" class="opacity-0 absolute pointer-events-none">
    <img src="/uploads/exhibit_1.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits1')" />
    <img src="/uploads/exhibit_2.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits2')" />
    <img src="/uploads/exhibit_3.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits3')" />
    <img src="/uploads/cable_monkey.png" alt="" @load="$store.commit('loader/setLoaded', 'monkey')" />
    <img src="/uploads/power_outlet.png" alt="" @load="$store.commit('loader/setLoaded', 'outlet')" />
    <img src="/uploads/concrete_structure.png" alt="" @load="$store.commit('loader/setLoaded', 'concrete')" />
    <img src="/uploads/ape_cable.png" alt="" @load="$store.commit('loader/setLoaded', 'ape')" />
    <img src="/uploads/exhibit_image_b.png" alt="" @load="$store.commit('loader/setLoaded', 'middle')" />
    <img
      src="/uploads/exhibit_background_b.jpg"
      alt=""
      @load="$store.commit('loader/setLoaded', 'background')"
    />
    <img src="/uploads/foreground_tree_b.png" alt="" @load="$store.commit('loader/setLoaded', 'foreground')" />
  </div>

  <div v-else-if="exhibit === 'exhibit_c'" class="opacity-0 absolute pointer-events-none">
    <img src="/uploads/exhibit_1.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits1')" />
    <img src="/uploads/exhibit_2.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits2')" />
    <img src="/uploads/exhibit_3.png" alt="" @load="$store.commit('loader/setLoaded', 'exhibits3')" />
    <img src="/uploads/cable_monkey.png" alt="" @load="$store.commit('loader/setLoaded', 'monkey')" />
    <img src="/uploads/power_outlet.png" alt="" @load="$store.commit('loader/setLoaded', 'outlet')" />
    <img src="/uploads/concrete_structure.png" alt="" @load="$store.commit('loader/setLoaded', 'concrete')" />
    <img src="/uploads/ape_cable.png" alt="" @load="$store.commit('loader/setLoaded', 'ape')" />
    <img src="/uploads/exhibit_c1.png" alt="" @load="$store.commit('loader/setLoaded', 'middle')" />
    <img src="/uploads/exhibit_c2.png" alt="" @load="$store.commit('loader/setLoaded', 'middle')" />
    <img src="/uploads/exhibit_c3.png" alt="" @load="$store.commit('loader/setLoaded', 'middle')" />
    <img src="/uploads/exhibit_c4.png" alt="" @load="$store.commit('loader/setLoaded', 'middle')" />
    <img src="/uploads/foreground_c1.png" alt="" @load="$store.commit('loader/setLoaded', 'foreground')" />
    <img src="/uploads/foreground_c2.png" alt="" @load="$store.commit('loader/setLoaded', 'foreground')" />
    <img src="/uploads/foreground_c3.png" alt="" @load="$store.commit('loader/setLoaded', 'foreground')" />
    <img src="/uploads/foreground_c4.png" alt="" @load="$store.commit('loader/setLoaded', 'foreground')" />
  </div>
</template>

<script>
export default {
  props: {
    exhibit: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style>
</style>